import { NumberInput } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  numberOfCards: number;
  setNumberOfCards: (name: number) => void;
}

export function NumberOfCards({ numberOfCards, setNumberOfCards }: IProps) {
  return (
    <NumberInput
      label="Fjöldi gjafakorta"
      allowNegatives={false}
      onChange={(numberOfGiftCards) => setNumberOfCards(numberOfGiftCards)}
      value={numberOfCards}
      id="fea"
      inputSize="big"
    />
  );
}
